<template>
  <v-app class="text">
    <h1>{{title}}</h1>
    <div v-html="content"></div>
  </v-app>
</template>

<script>
  import axios from "axios";

  export default {
    data: () => {
      return {
        title: '',
        content: '',
      };
    },
    props: {
      text_id: Number
    },
    created () {
      // fetch the data when the view is created and the data is
      // already being observed
      console.log('created');
      this.fetchData()
    },
    watch: {
      // call again the method if the route changes
      '$route': 'fetchData'
    },
    methods: {
      fetchData () {
        if (this.text_id) {
          axios.get('https://leerdoelen.harry.niolab.nl/backend/api/v1/text/view',{params:{'id':this.text_id}})
            .then((response) => {
              console.log(response.data);
              this.title = response.data['title'];
              this.content = response.data.content;
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      }
    }
  }
</script>